import { render, staticRenderFns } from "./LinkWithApisOrders.vue?vue&type=template&id=13a8f0e4&scoped=true"
import script from "./LinkWithApisOrders.vue?vue&type=script&lang=js"
export * from "./LinkWithApisOrders.vue?vue&type=script&lang=js"
import style0 from "./LinkWithApisOrders.vue?vue&type=style&index=0&id=13a8f0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a8f0e4",
  null
  
)

export default component.exports